export default __webpack_public_path__ + "static/media/668.dbcd53ed.png";